import { radioAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/react";

import { focusRingInline } from "theme/tokens/accessibility";

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  radioAnatomy.keys,
);

const getCheckedStyles = (color: string, bg: string = "bg.container") => ({
  _checked: {
    background: bg,
    borderColor: color,
    color: color,
    _hover: {
      background: bg,
      borderColor: color,
      color: color,
    },
    _focus: {
      boxShadow: "none",
    },
  },
});

const baseStyleContainer = defineStyle({
  _disabled: { cursor: "default" },
});

const baseStyleControl = defineStyle({
  borderColor: "neutral.emphasized",
  background: "bg.container",
  transitionProperty: "opacity",
  transitionDuration: (theme) => theme.transition.duration.extraFast,
  transitionTimingFunction: (theme) => theme.transition.easing.easeOut,
  _focusVisible: {
    ...focusRingInline,
  },
  ...getCheckedStyles("highlight.solid"),
  _disabled: {
    borderColor: "neutral.muted",
    background: "neutral.subtle",
    ...getCheckedStyles("neutral.muted", "neutral.subtle"),
  },
});

const baseStyleLabel = defineStyle({
  _disabled: { opacity: 1 },
});

export const Radio = defineMultiStyleConfig({
  baseStyle: {
    container: baseStyleContainer,
    control: baseStyleControl,
    label: baseStyleLabel,
  },
});
